const _ = require('lodash');

const vb = require('../definition');

vb.fileHasAllowedExtensions = (allowedExtensions, message) => {
	return {
		validator: f => {
			const name = f && f.Name();

			if (!f || !name) {
				return true;
			}

			return _.some(allowedExtensions, ext => name.toLowerCase().endsWith('.' + ext));
		},
		message: message || [
			`Загружаемый файл не соответсвует формату: .${allowedExtensions.join(', .')}`,
			`только .${allowedExtensions.join(', .')}`,
			'недопустимый формат файла',
		],
	};
};
